<template>
    <div class="menuall_RWD">
        <!--首頁類別選單-手機板-->
        <div class="tright">
            <!--漢堡選單按鈕-->
            <div id="trigger-overlay" class="in-burger">
                <span></span>
            </div>
        </div>
        <!--漢堡列表本體-->
        <div class="overlay overlay-hugeinc RWD_mnuopen">
            <!--關閉按鈕-->
            <button type="button" class="overlay-close">Close</button>
            <!--網站導覽列表-->
            <div class="rwd_tplink">
                <div class="tplink">
                    <!--網站導覽-->
                    <span style="margin-left:8px;">
                        <a href="/Sitemap">網站導覽</a>
                    </span>
                    |
                    <!--台大網站-->
                    <span>
                        <a href="https://www.ntu.edu.tw/" target="_blank" title="臺大官網(另開新視窗)">臺大首頁</a>
                    </span>
                </div>
            </div>
            <!--類別列表-->
            <nav>
                <div>
                    <ul>
                        <!--最新消息-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/News">最新消息</a>
                        </li>
                        <!--關於生傳-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/About">關於生傳</a>
                        </li>
                        <!--系所成員-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/Member">系所成員</a>
                        </li>
                        <!--招生訊息-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/Admissions">招生訊息</a>
                        </li>
                        <!--課程資訊-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/Curriculum">課程資訊</a>
                        </li>
                        <!--碩士在職專班-->
                        <li>
                            <!--主類別標題文字-->
                            <a href="/InServiceMaster">碩士在職專班</a> 
                        </li>
                        <!--學術研究-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/Research">學術研究</a>
                        </li>
                        <!--常用表單-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="/Forms">常用表單</a>
                        </li>
                        <!--友站連結-->
                        <li>
                            <!--主類別標題文字-->
                            <!-- TODO 動態抓取文字-->
                            <a href="#" class="rwsttf">友站連結</a>
                            <!--連結欄位-->
                            <div class="rwsbwd">
                                <!---->
                                <div clas="rwd_sbsel" v-for="(item, index) in GetSublist('PJ202510').filter(x => { return x.modal==langurage })">
                                    <a :href="item.PJ_ENAME" target="_blank">
                                        {{ item.PJ_NAME }}
                                    </a>
                                </div>
                            </div>
                        </li>
                        <!--全站搜尋-->
                        <li>
                            <div class="searchall">
                                <b-form-input id="textfield_RWD" name="textfield_RWD" class="seahbox" v-model="searchKeyWords" placeholder="全站搜尋" ></b-form-input>
                                <div class="seahbtn" >
                                    <!--搜尋按鈕-->
                                    <a href="javascript:" @click="search()" title="開始查詢" role="button">
                                        <img src="/images/search.png" alt="搜尋"/>
                                    </a>
                                </div>
                            </div>
                        </li>
                        <!--切換語系-->
                        <li>
                            <div class="langall">
                                <!-- TODO 動態寫入目前語系 & 判斷下拉選單目前語系並套用Class-->
                                中文
                                <div class="lanselb">
                                    <!--當前語系套用aclang這個class-->
                                    <div class="lanbx">
                                        <a class="aclang">中文</a>
                                    </div>
                                    <div class="lanbx">
                                        <a @click="gotoEN()">English</a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return {
            searchKeyWords:"",
             //目前單元
            place:"",
            langurage: "1",
            //內容資料
            headerData:[],
        };
    },
    props:["menulist"],
    mounted(){
        //初始化
        this.init();
        this.getHeader();
    },
    watch:{},
    methods:{
        //初始化
        init(){
            //2025-11-14 移除全站查詢bootstrape 預設樣式
            $('#textfield_RWD').removeClass('form-control');
            //2025-11-14 讀取RWD選單功能的js
            const script = document.createElement("script");
            script.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
            script.src = "/js/classie.js";
            document.body.appendChild(script);
            const script1 = document.createElement("script");
            script1.setAttribute('nonce', 'SHhzTzNmaWIxZjZJWmVsRg==');
            script1.src = "/js/demo1.js";    
            document.body.appendChild(script1);

            //取得目前所在類別
            this.place = this.menulist.place;
            if(this.$route.query){
                this.langurage = this.$route.query.lang? this.$route.query.lang: "1";
            }
        },
         //取得所有類別欄位
        async getHeader(){
            try {
                //POST 參數
                let jsonReq = {
                    TYPE:"GET_MENU_OPTION",
                    langurage:this.langurage,
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/Project",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //設定類別
                    this.headerData = jsonData;
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得切割類別
        GetSublist(PJ_ID){
            //判斷資料列表是否存在，無則回傳空值
            if (!Array.isArray(this.headerData)) return [];
            //TODO 僅取得指定類別的所有次類別資料
             var headerDatas = [];
            if(this.headerData.filter(item => item.PJ_ID == PJ_ID).length >0){
                headerDatas = (this.headerData.filter(item => item.PJ_ID == PJ_ID))[0].SubList;
            }else{
                return [];
            }
            return headerDatas;
        },
        search() {
            this.functionSearch(this.searchKeyWords);
        },
        //查詢功能
        functionSearch(data){
            if(data==null){
                alert('請輸入關鍵字');
            }else{
                //TODO 前往全站搜尋頁面
                this._go1("/Search?q="+encodeURIComponent(data));
            }
        },
        //前往當前頁面英文版
        gotoEN(){
            this.$router.push({
                path: "/EN" +this.$route.path,
                query:this.$route.query,
            });
        },
    },
}
</script>